import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'auto-logout-dialog',
    templateUrl: './auto-logout-dialog.component.html',
    styleUrls: ['./auto-logout-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AutoLogoutDialogComponent implements OnInit, OnDestroy {
  public message: string;
  public unit: string;
  timeLeft = 60;
  endTime: number;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<AutoLogoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _translateService: TranslateService,
  ) {
    // Calculate exact future timestamp based on the timeout duration passed from app component
    const timeoutSeconds = this._data?.timeout || 5; 
    this.timeLeft = timeoutSeconds; // Initialize immediately to prevent flicker
    this.endTime = Date.now() + (timeoutSeconds * 1000);
    
    timer(0, 1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.recalculateTime();
      });
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.recalculateTime();
    }
  }

  private recalculateTime() {
    // Recalculate remaining seconds based on the system clock rather than simple subtraction
    this.timeLeft = Math.max(0, Math.ceil((this.endTime - Date.now()) / 1000));
    
    if (this.timeLeft <= 0) {
      // Force the app to completely log out when the visual countdown expires
      this.dialogRef?.close('logout');
    }
  }
 
  ngOnInit(): void {
    this.message = this._translateService.instant('Log out due to inactivity in');
    this.unit = this._translateService.instant('sec');
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

}
